import { type UseQueryResult, useQuery } from 'react-query';
import { StatusDropdownAppServicesService } from '../../services/wealthlane-award-services';

const useGetTransactionAcquisitionOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: number | string;
    }>
  | undefined,
  unknown
> => {
  const transactionAcquisitionOptions = useQuery(
    ['getTransactionAcquisitionOptions'],
    async () => {
      return await handleRequest(
        StatusDropdownAppServicesService.getApiAwardApiAppStatusDropdownAppServicesTransactionAcquisitionTypes()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return transactionAcquisitionOptions;
};

export default useGetTransactionAcquisitionOptions;
